export default __webpack_public_path__ + "static/328-542d2f850181fad3c8354c61202732c1.gif";